import { useState } from "react";
import { NameInitialsAvatar } from "react-name-initials-avatar";
import { useUsers } from "@/entities/users/model/useUsers";
interface Props {
  assignee: string | undefined;
}
export default function AlertAssignee({
  assignee
}: Props) {
  const [imageError, setImageError] = useState(false);
  const {
    data: users = []
  } = useUsers();
  if (!assignee) {
    return null;
  }
  const user = users.find(user => user.email === assignee);
  const userName = user?.name || assignee;

  // If users haven't loaded yet, show a simple text fallback
  if (users.length === 0) {
    return <div className="flex items-center gap-2">
        <div className="h-8 w-8 rounded-full bg-orange-100 flex items-center justify-center">
          <span className="text-xs font-medium text-orange-600">
            {assignee.charAt(0).toUpperCase()}
          </span>
        </div>
        <span className="text-sm text-gray-700 truncate" title={assignee}>
          {assignee}
        </span>
      </div>;
  }
  return !imageError ?
  // eslint-disable-next-line @next/next/no-img-element
  <img className="h-8 w-8 rounded-full" src={user?.picture || `https://ui-avatars.com/api/?name=${userName}&background=random`} height={24} width={24} alt={`${assignee} profile picture`} onError={() => setImageError(true)} title={assignee} data-sentry-component="AlertAssignee" data-sentry-source-file="alert-assignee.tsx" /> : <NameInitialsAvatar name={userName} bgColor="orange" borderWidth="1px" textColor="white" size="32px" data-sentry-element="NameInitialsAvatar" data-sentry-component="AlertAssignee" data-sentry-source-file="alert-assignee.tsx" />;
}